module.exports = __webpack_public_path__ + "img/61f13c4f617d10e1a068f5449aa86eb5.png";